import React, { Fragment, useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDesktop, faSearch } from '@fortawesome/free-solid-svg-icons'
import '../../../styles/diario.scss'


function HomeScreen() {
    const [direct, setDirect] = useState(false);


    if (direct) {
        return <Navigate to={{ pathname: `${direct}` }} />
    } else {
        return (
            <Fragment>
                <Container>
                    <Row xs={1} lg={2}>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/cadastrar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faDesktop} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Solicitar Especificações Técnicas</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col>
                            <Card className='card-list' onClick={e => setDirect('/consultar')}>
                                <Card.Body>
                                    <Row xs={1}>
                                        <Col>
                                            <Row xs={1}>
                                                <Col>
                                                    <FontAwesomeIcon className='icon-cad' icon={faSearch} />
                                                </Col>
                                                <Col>
                                                    <p className='titulo-home'>Consultar Solicitação</p>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        );
    }
}

export default HomeScreen;